import Fuse from "fuse.js"

export const PRODUCT_FUSE_OPTIONS = {
  keys: [
    { name: 'name', weight: 0.6 },
    { name: 'supplierName', weight: 0.2 },
    { name: 'categoryName', weight: 0.2 },
  ],
  threshold: 0.4,
  distance: 100,
}

// Search a single shared Fuse index and scope results to a store. We keep ONE
// 'all' index (every product, enriched once) instead of an index per store, then
// filter by activeInStore here — reproduces exactly what a per-store index returned
// (activeOnly + store) without holding (stores+1)×products clones in memory (ATL-631).
export const searchProductsByStore = (fuse, query, store = null, opts = undefined) => {
  if (!fuse) return []
  const results = fuse.search(query, opts)
  // Only the explicit 'all' sentinel is unscoped. An unresolved store (null/undefined,
  // e.g. userStoreId not loaded yet) must NOT leak other stores' products — it filters
  // to empty, matching the browse path's filterByStore() 'notFound' behaviour (ATL-631).
  if (store === 'all') return results
  return results.filter((r) => r.item.activeInStore?.[store])
}

export const newFuse = (products) => {
  const fuseOptions = PRODUCT_FUSE_OPTIONS
  let productList = []
  for (let productCategory of products) {
    for (let product of productCategory.data) {
      productList.push({...product, categoryName: productCategory.title})
    }
  }
  let newFuse = new Fuse(productList, fuseOptions) 
  return newFuse
}